import type Route from '@/Enums/Routes/Route.enum';
import PageTitle from '@/components/PageTitle';
import { ReactNode } from 'react';
import ContentLoadingSkeleton from '../layout/AppLayout/ContentLoadingSkeleton';
import Forbidden from '../pages/Forbidden';
import FallbackRoute from './FallbackRoute';

interface IProps {
  token: string;
  mainFallback: Route;
  screenTitle?: string;
  children: ReactNode;
  meLoading: boolean;
  isAllowed: boolean;
}

const AppRoute = ({ token, meLoading, isAllowed, children, mainFallback, screenTitle }: IProps) => {
  if (!token) {
    return <FallbackRoute token={token} />;
  }
  if (meLoading) {
    return <ContentLoadingSkeleton />;
  }
  if (!isAllowed && mainFallback) {
    return <FallbackRoute token={token} mainFallback={mainFallback} />;
  }
  if (!isAllowed) {
    return <Forbidden />;
  }
  return (
    <>
      <PageTitle screenTitle={screenTitle} />
      {children}
    </>
  );
};

export default AppRoute;
